import React, { useState } from "react";
// import { Link } from "react-router-dom";

//
//

import SimurghGrid from "./SimurghGrid";
import SimurghModal from "./SimurghModal";

//

function Simurgh() {
  //
  //
  const [selectedSimurgh, setSelectedSimurgh] = useState(null);

  //
  //

  return (
    <React.Fragment>
      <SimurghGrid setSelectedSimurgh={setSelectedSimurgh} />
      {/* 
  
  
     */}
      {selectedSimurgh && (
        <SimurghModal
          selectedSimurgh={selectedSimurgh}
          setSelectedSimurgh={setSelectedSimurgh}
        />
      )}

      {/* ------------- */}
      {/* ------------- */}
    </React.Fragment>
  );
}

export default Simurgh;
